module.exports = __webpack_public_path__ + "static/media/Apple iPhone 11 Red.47019676.png";